/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

import partnerWebinarQuestions from "./onboardingQuestions";

export default partnerWebinarQuestions;
